/* Nexus v22.2 behaviour · Designed by Kavalsia Inc. */
(function () {
  'use strict';
  var html = document.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) html.classList.remove('nx-anim');

  /* This theme scrolls inside .page-wrapper when the body is locked; fall back to the window */
  var pw = document.querySelector('.page-wrapper');
  function inner() { return pw && pw.scrollHeight > pw.clientHeight + 4 && getComputedStyle(document.body).overflowY === 'hidden'; }
  function getY() { return inner() ? pw.scrollTop : scrollY; }
  function getMax() { return inner() ? pw.scrollHeight - pw.clientHeight : html.scrollHeight - innerHeight; }
  function onAnyScroll(fn) { addEventListener('scroll', fn, { passive: true }); if (pw) pw.addEventListener('scroll', fn, { passive: true }); }

  /* Intro curtain: once per session */
  var curtain = document.querySelector('.nx-curtain');
  if (curtain) {
    var lifted = false;
    var lift = function () { if (lifted) return; lifted = true; curtain.classList.add('is-done'); setTimeout(function () { curtain.remove(); }, 1400); };
    if (reduce) curtain.remove(); else { setTimeout(lift, 900); }
  }

  /* Reveal: observer + sweep + safety timeout */
  var pending = new Set(document.querySelectorAll('.nx-reveal'));
  function reveal(el, i) { if (!pending.has(el)) return; pending.delete(el); el.style.setProperty('--d', Math.min(i * 0.08, 0.4) + 's'); el.classList.add('is-in'); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { var n = 0; es.forEach(function (e) { if (e.isIntersecting || e.boundingClientRect.top < 0) { reveal(e.target, n++); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -6% 0px' });
    pending.forEach(function (el) { io.observe(el); });
  }
  function sweep() { var due = []; pending.forEach(function (el) { if (el.getBoundingClientRect().top < innerHeight * 0.96) due.push(el); }); return due; }
  setTimeout(function () { pending.forEach(function (el) { reveal(el, 0); }); }, 3500);

  /* Progress line, header shadow, parallax */
  var bar = document.querySelector('.nx-progress');
  var par = [].slice.call(document.querySelectorAll('[data-nx-parallax]'));
  var ticking = false;
  function onScroll() {
    ticking = false;
    /* Read everything first, then write, so the browser lays out once per frame */
    var y = getY(), max = getMax(), due = sweep(), vh = innerHeight;
    var shift = reduce ? [] : par.map(function (el) { var r = el.parentElement.getBoundingClientRect(); return ((r.top + r.height / 2 - vh / 2) / vh * -24).toFixed(1) + 'px'; });
    if (bar) bar.style.setProperty('--p', max > 0 ? Math.min(y / max, 1) : 0);
    html.classList.toggle('nx-scrolled', y > 12);
    due.forEach(function (el, i) { reveal(el, i); });
    shift.forEach(function (v, i) { if (par[i].style.getPropertyValue('--nx-par') !== v) par[i].style.setProperty('--nx-par', v); });
  }
  onAnyScroll(function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } });
  onScroll();

  /* Hero prism follows the pointer (desktop only); once per frame, written on the prism itself */
  document.querySelectorAll('.nx-hero').forEach(function (h) {
    var pr = h.querySelector('.nx-hero__prism');
    if (!pr || reduce || !matchMedia('(hover: hover)').matches) return;
    var px = 0, py = 0, queued = false;
    var paint = function () { queued = false; var r = h.getBoundingClientRect(); pr.style.setProperty('--nx-px', ((px - r.left) / r.width * 100).toFixed(1) + '%'); pr.style.setProperty('--nx-py', ((py - r.top) / r.height * 100).toFixed(1) + '%'); };
    h.addEventListener('pointermove', function (e) { px = e.clientX; py = e.clientY; if (!queued) { queued = true; requestAnimationFrame(paint); } });
  });

  /* Endless animations rest while their section is off screen (see nexus-mobile.css .nx-off) */
  if ('IntersectionObserver' in window && !reduce) {
    var rest = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('nx-off', !e.isIntersecting); }); });
    document.querySelectorAll('.nx-hero, .nx-colhero, .nx-service, .nx-grain').forEach(function (el) { rest.observe(el); });
  }

  /* Slow ambient drifts (hero smoke, clouds, zoom, light, grain): the same motion, redrawn 30 times a second
     instead of on every display refresh (120 on ProMotion screens), so the GPU has a quarter of the work */
  if (!reduce && document.getAnimations && document.timeline) {
    var drifts = [], lastTick = 0;
    var tick = function (now) {
      if (now - lastTick >= 32) { lastTick = now; var tl = document.timeline.currentTime; drifts.forEach(function (d) { if (!d.sec.classList.contains('nx-off')) d.a.currentTime = tl - d.base; }); }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      document.querySelectorAll('.nx-hero, .nx-colhero').forEach(function (sec) {
        sec.getAnimations({ subtree: true }).forEach(function (a) {
          var t = a.effect && a.effect.getComputedTiming();
          if (!t || t.iterations !== Infinity || /drop/.test(a.animationName || '') || a.currentTime == null) return;
          drifts.push({ a: a, sec: sec, base: document.timeline.currentTime - a.currentTime }); a.pause();
        });
      });
      if (drifts.length) requestAnimationFrame(tick);
    }); });
  }

  /* Shop by colour glow (WebGL): while nothing is changing, redraw its film grain 30 times a second rather than every refresh */
  var Lens = window.customElements && customElements.get('nx-lens');
  if (Lens && !Lens.prototype._nxSlow) {
    var lensDraw = Lens.prototype.draw;
    Lens.prototype._nxSlow = true;
    Lens.prototype.draw = function (t) {
      var m = this.mouse, mt = this.mt;
      var still = !this.reduce && !this.anim && m && mt && Math.abs(mt[0] - m[0]) < .002 && Math.abs(mt[1] - m[1]) < .002;
      if (still && this._nxT != null && t >= this._nxT && t - this._nxT < 32) return;
      this._nxT = t;
      return lensDraw.call(this, t);
    };
  }

  /* Tabs */
  document.querySelectorAll('[data-nx-tabs]').forEach(function (root) {
    var tabs = [].slice.call(root.querySelectorAll('[role=tab]'));
    function select(t, focus) {
      tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; var p = document.getElementById(x.getAttribute('aria-controls')); if (p) { p.hidden = !on; if (on) { p.querySelectorAll('.nx-reveal').forEach(function (r) { reveal(r, 0); }); p.classList.remove('is-entering'); void p.offsetWidth; p.classList.add('is-entering'); } } });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) { var k = e.key; if (k === 'ArrowRight' || k === 'ArrowLeft') { e.preventDefault(); select(tabs[(i + (k === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length], true); } });
    });
  });

  /* Signature gallery */
  document.querySelectorAll('[data-nx-gallery]').forEach(function (g) {
    g.querySelectorAll('.nx-feature__thumb').forEach(function (t) {
      t.addEventListener('click', function () { g.querySelectorAll('.nx-feature__slide, .nx-feature__thumb').forEach(function (s) { s.classList.toggle('is-active', s.dataset.i === t.dataset.i); }); g.querySelectorAll('.nx-feature__thumb').forEach(function (b) { b.setAttribute('aria-selected', b === t); }); });
    });
  });

  /* Variant options in the signature block */
  document.querySelectorAll('[data-nx-variants]').forEach(function (form) {
    var data; try { data = JSON.parse(form.querySelector('[data-nx-json]').textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name=id]');
    var price = form.closest('.nx-feature__info').querySelector('[data-nx-price]');
    var btn = form.querySelector('[data-nx-add]');
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[data-nx-opt]')) return;
      var v = data.filter(function (x) { return String(x.id) === e.target.value; })[0];
      if (!v) return;
      idInput.value = v.id;
      if (price) price.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      if (btn) { btn.disabled = !v.available; btn.lastElementChild.textContent = v.available ? btn.dataset.add : btn.dataset.sold; }
    });
  });

  /* Add to cart without leaving the page */
  var toast;
  function showToast(item, ok) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'nx-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    var img = item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="">' : '<span></span>';
    toast.innerHTML = img + '<div><strong>' + (ok ? 'Added to your cart' : 'Not added') + '</strong>' + (item.product_title || '') + (ok ? '<div class="nx-toast__links"><a href="/cart">View cart</a><a href="/checkout">Checkout</a></div>' : '') + '</div>';
    requestAnimationFrame(function () { toast.classList.add('is-open'); });
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-open'); }, 6000);
  }
  function updateCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { el.textContent = c.item_count; });
      document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', c.item_count === 0); });
      document.dispatchEvent(new CustomEvent('nx:cart', { detail: c }));
    }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-nx-cart]')) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); var lab = b && b.lastElementChild; var label = lab ? lab.textContent : '';
    if (b) { b.disabled = true; if (lab) lab.textContent = 'Adding…'; }
    var done = function () { if (b) { b.disabled = false; if (lab) lab.textContent = label; } };
    /* Open the cart drawer, as the product page does; the toast is the fallback where there is no drawer */
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart && actions.openCart && document.getElementById('cart-drawer')) {
      var fd = new FormData(f);
      Promise.resolve(actions.updateCart({ lines: [{ merchandiseId: String(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] }))
        .then(function (res) { if (res && res.userErrors && res.userErrors.length) throw { description: res.userErrors[0].message }; return actions.openCart(); })
        .then(updateCount)
        .catch(function (err) { showToast({ product_title: (err && (err.description || err.message)) || 'Please try again.' }, false); })
        .then(done);
      return;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) { showToast(item, true); updateCount(); })
      .catch(function (err) { showToast({ product_title: (err && err.description) || 'Please try again.' }, false); })
      .then(done);
  });

  /* Copy code buttons */
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-nx-copy]');
    if (!c) return;
    var code = c.dataset.nxCopy, lab = c.lastElementChild;
    var done = function () { c.classList.add('is-copied'); lab.textContent = 'Copied'; setTimeout(function () { c.classList.remove('is-copied'); lab.textContent = 'Copy'; }, 2400); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () {});
  });

  /* Tints: ambient glow follows the hovered colour */
  document.querySelectorAll('.nx-tints').forEach(function (band) {
    band.querySelectorAll('.nx-tint a').forEach(function (a) {
      var set = function () { var r = band.getBoundingClientRect(), t = a.getBoundingClientRect(); band.style.setProperty('--glow', a.dataset.glow); band.style.setProperty('--gx', ((t.left + t.width / 2 - r.left) / r.width * 100).toFixed(1) + '%'); };
      a.addEventListener('mouseenter', set); a.addEventListener('focus', set);
    });
  });

  /* Welcome offer: non-blocking, after a delay or 45% scroll, snooze 7 days */
  var pop = document.getElementById('nx-pop');
  if (pop) {
    var pill = document.getElementById('nx-pill');
    var store = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
    var blocked = /^\/(cart|checkout|account|checkouts)/.test(location.pathname);
    var joined = store.get('nx_joined') === '1';
    var snoozed = Number(store.get('nx_snooze') || 0) > Date.now();
    var fired = false;
    var open = function () { if (fired) return; fired = true; pop.hidden = false; if (pill) pill.hidden = true; requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); }); };
    var close = function () { pop.classList.remove('is-open'); setTimeout(function () { pop.hidden = true; if (pill && !joined) pill.hidden = false; }, 450); store.set('nx_snooze', String(Date.now() + 7 * 864e5)); };
    if (pop.dataset.state === 'success' || pop.dataset.state === 'error') { if (pop.dataset.state === 'success') { joined = true; store.set('nx_joined', '1'); } open(); }
    else if (!blocked && !joined) {
      if (snoozed) { if (pill) pill.hidden = false; }
      else {
        setTimeout(open, Number(pop.dataset.delay || 20) * 1000);
        var deep = false;
        onAnyScroll(function () { if (fired || deep) return; deep = true; requestAnimationFrame(function () { deep = false; var m = getMax(); if (m > 0 && getY() / m > 0.45) open(); }); });
        setTimeout(function () { if (matchMedia('(hover: hover)').matches) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 4) open(); }); }, 8000);
      }
    }
    pop.querySelector('.nx-pop__close').addEventListener('click', close);
    if (pill) pill.addEventListener('click', function () { fired = false; open(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
  }
})();
